module.exports = __webpack_public_path__ + "img/tu01.214ee1fd.jpg";